import { atom } from "recoil";
import { ModalType } from "../@types";

export const PromoSession = atom({
  key: "PromoSession_v0.1",
  default: {
    loaded: false,
    refetch: false,
    activeCarouselPromos: [],
    activeSiteSideRailAd: {
      title: "",
      subtitle: "e",
      image: "",
      link: "",
      buttonCopy: "",
    },
    activeSiteVideoPlayerPromos: [],
    activeSiteTopBanner: {
      buttonAction: ModalType.None,
      link: "",
      colorCSS: "",
      content: "",
      external: "",
      name: "",
      endDate: "",
      __typename: "",
    },
    activeSiteFirstLandModal: [],
    activeSitePaywallPromo: {
      topBannerCopy: "",
      colorCSS: "",
      link: "",
      endDate: "",
      countdownBackgroundColor: null,
      countdownFontColor: null,
      countdownSubFontColor: null,
    },
    activeUpgradePagePromo: {
      pricing: {
        monthly: {
          essentials: "",
          pro: "",
          proPlus: "",
          platinum: "",
        },
        annual: {
          essentials: "",
          pro: "",
          proPlus: "",
          platinum: "",
        },
      },
      savings: {
        monthly: {
          essentials: "",
          pro: "",
          proPlus: "",
          platinum: "",
        },
        annual: {
          essentials: "",
          pro: "",
          proPlus: "",
          platinum: "",
        },
      },
      productIds: {
        monthly: {
          essentials: "",
          pro: "",
          proPlus: "",
          platinum: "",
        },
        annual: {
          essentials: "",
          pro: "",
          proPlus: "",
          platinum: "",
        },
      },
      pcntOff: {
        upTo: "",
        monthly: {
          essentials: "",
          pro: "",
          proPlus: "",
          platinum: "",
        },
        annual: {
          essentials: "",
          pro: "",
          proPlus: "",
          platinum: "",
        },
      },
      imageUrl: "",
      endDate: "",
      countdownBackgroundColor: "",
      countdownFontColor: "",
      countdownSubFontColor: "",
      countdownTimerOffset: 0,
      countdownTimerHorizontalOffset: 0,
      name: "",
    },
    activeClipPagePromos: [],
  },
});
